import { render, staticRenderFns } from "./EditorForCockpit.vue?vue&type=template&id=e001358e&lang=pug&"
import script from "./EditorForCockpit.vue?vue&type=script&lang=ts&"
export * from "./EditorForCockpit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports